export default __webpack_public_path__ + "images/org-mock-82-100-100.jpg";